import { UserNotification } from "@interfaces/user/users";
import { createContext, useContext } from "react";

const NotificationContext = createContext<UserNotification>(undefined as any);
export const NotificationProvider = NotificationContext.Provider;

export function useNotificationContext(): UserNotification | undefined {
    return useContext(NotificationContext);
}